
const unwantedProps = [
  'id',
  'invitedBy',
  'modifiedAt',
  'modifiedBy',
  'registrationDate',
  'version'
]

export default (data = {}) => {
  const initialValues = {
    ...data
  }

  Object.keys(initialValues).map(key => {
    if (unwantedProps.includes(key)) {
      delete initialValues[key]
    }
  })

  return initialValues
}
